import moment from "moment";
import {defaultData} from "./state";

export function setAvailabilityWmsProducts (state, data) {
    state.availabilityWmsProducts = data;
}

export function setProductIDDataProductsWms (state, data) {
    state.dataProductsWms.product_id = data;
}

export function resetDefaultFormProduct (state) {
    Object.assign(state.dataProductsWms, defaultData());
}



// WEBPACK FOOTER //
// ./src/modules/modal-list-product-wms/mutations.js